import React from 'react';

export function Links() {
  // Global __LINKS__ is injected at build time by the inject-content Vite plugin
  const links = typeof __LINKS__ !== 'undefined' ? __LINKS__ : [];

  return (
    <div>
      <h2>Useful Links</h2>
      {links.length === 0 ? (
        <p>No links configured</p>
      ) : (
        <ul>
          {links.map((link: { title: string; url: string }, idx: number) => (
            <li key={idx}>
              <a href={link.url} target="_blank" rel="noopener noreferrer">
                {link.title}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
